import useOneLinkUrl from "hooks/useOneLinkUrl";
import Link from "next/link";
import QRCode from "react-qr-code";
import { Trans } from "@lingui/macro";

const VideoQrContainer: React.FunctionComponent = () => {
  return (
    <div>
      <div className="block sm:hidden">
        <MobileVideoQrContainer />
      </div>
      <div className="hidden sm:block">
        <DesktopVideoQrContainer />
      </div>
    </div>
  );
};

const MobileVideoQrContainer: React.FunctionComponent = () => {
  const deepLinkValue = useOneLinkUrl(
    "https://link.luminews.my/ewC9/switchtoappbutton",
    true
  );

  return (
    <div className="my-12 flex flex-col justify-center">
      <p className="text-center font-poppins text-2xl font-bold text-text-darkest">
        <Trans>Videos are better on the Lumi News app</Trans>
      </p>
      <p className="pt-2 text-center font-sen text-text-medium">
        <Trans>
          Use the app for a better experience. We'll tell you when something
          trends
        </Trans>
      </p>
      <Link href={deepLinkValue}>
        <a className="mx-6 mt-6 rounded-2xl bg-primary p-4 text-center font-sen text-white">
          <Trans>Switch to the app</Trans>
        </a>
      </Link>
    </div>
  );
};

const DesktopVideoQrContainer: React.FunctionComponent = () => {
  const deepLinkValue = useOneLinkUrl(
    "https://link.luminews.my/ewC9/qrdl",
    true
  );
  return (
    <div className="flex flex-col justify-center sm:my-12">
      <div className="flex justify-center">
        <div className="rounded-lg border border-text-lightest">
          <QRCode className="m-2" value={deepLinkValue} size={150} />
        </div>
      </div>
      <div className="mx-32">
        <div className="mt-4 text-center font-poppins text-xl font-bold">
          <Trans>Videos are better on the Lumi News app</Trans>
        </div>
        <div className="mt-1 text-center font-sen text-sm text-text-medium">
          <Trans>
            Use the app for a better experience. We'll tell you when something
            trends
          </Trans>
        </div>
      </div>
    </div>
  );
};

export default VideoQrContainer;
